<script setup lang="ts">
const { user } = useUser()
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/default.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<content-wrapper>
		<team-submenu />

		<ui-alert variant="informative">
			{{ t('views.teams.subscription.content') }}
		</ui-alert>

		<div class="mt-3 text-sm">
			{{ t('app.current_subscription_set_to') }}: <strong>{{ user.current_team?.plan.label }}</strong>
		</div>
	</content-wrapper>
</template>
